import {
  initializeFirestore,
  getFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  persistentSingleTabManager,
} from "firebase/firestore";
import { isIosWebKit } from "../utils/isIosWebKit";
import { initFirestoreSyncService } from "../services/firebase/firestoreSyncService";

/**
 * Firestore with native offline persistence (IndexedDB).
 * Dev uses single-tab manager to avoid HMR / StrictMode multi-tab races that
 * corrupt IndexedDB (canonifyTarget null / INTERNAL ASSERTION on refresh).
 * iOS uses single-tab as well: multi-tab leader election deadlocks Safari and
 * the first profile read never returns. Other production browsers keep multi-tab.
 * Falls back to default Firestore if persistence cannot be enabled.
 * @param {import('firebase/app').FirebaseApp} app
 */
export function createFirestoreWithPersistence(app) {
  try {
    const tabManager =
      process.env.NODE_ENV === "development" || isIosWebKit()
        ? persistentSingleTabManager()
        : persistentMultipleTabManager();
    const db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager,
      }),
    });
    initFirestoreSyncService(db, { persistenceReady: true, error: null });
    return db;
  } catch (err) {
    const db = getFirestore(app);
    const message =
      err && typeof err.message === "string" ? err.message : "Persistence unavailable";
    initFirestoreSyncService(db, { persistenceReady: false, error: message });
    return db;
  }
}
